export default __webpack_public_path__ + "static/media/v45_33.ee51856d.png";